import { Component, OnInit } from '@angular/core';
import { EditPostTemplate } from '../../../models/inModels/PostTemplate';
import { Message } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { PostTemplateService } from '../../../services/post-template.service';
import { StorageService } from '../../../services/system/storage.service';

@Component({
  selector: 'app-post-template-edit',
  templateUrl: './post-template-edit.component.html',
  styleUrls: ['./post-template-edit.component.css']
})
export class PostTemplateEditComponent implements OnInit {

  id;
	model: EditPostTemplate;
	loading = false;
	error: Message[];
	uploading = false;
	postTemplates;
  imageIds: string[] ;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private service: PostTemplateService,
		private storageService: StorageService
  ) {
    this.id = this.route.snapshot.paramMap.get('Id');
   }

  ngOnInit() {
    this.getPostTemplate();
  }

  getPostTemplate() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditPostTemplate(result);
        this.imageIds = this.model.ImageIds.split(',');
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  goBack(): void {
		this.router.navigate(['/post-templates']);
  }

  save() {
		this.loading = true;
    this.model.ImageIds = this.imageIds.join(',');
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditPostTemplate(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Template saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }

  handleImages(event): void {
		var result = this.storageService.handleSuccess(event);
    this.imageIds.push(result.PublicId);
    console.log("🚀 ~ file: post-template-edit.component.ts:75 ~ PostTemplateEditComponent ~ handleImages ~ this.imageIds:", this.imageIds)
		this.loading = false;
	}

  removeImages(imageId: string): void {
		this.imageIds = this.imageIds.filter(x => x != imageId);
	}

  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/post-template/post-template-edit/post-template-edit.component.ts